import { render, staticRenderFns } from "./KintaiPatternCard.vue?vue&type=template&id=20486953&scoped=true&"
import script from "./KintaiPatternCard.vue?vue&type=script&lang=ts&"
export * from "./KintaiPatternCard.vue?vue&type=script&lang=ts&"
import style0 from "./KintaiPatternCard.vue?vue&type=style&index=0&id=20486953&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20486953",
  null
  
)

export default component.exports